// @flow

import type Home from 'models/Home';

export const FAVORITE_BY_USER: 'favorite-home/user/all' = 'favorite-home/user/all';
export const POST_FAVORITE_HOME_USER: 'favorite-home/post' = 'favorite-home/post';
export const DELETE_FAVORITE_HOME_USER: 'favorite-home/delete' = 'favorite-home/delete';
export const FAVORITE_USER_ERROR: 'favorite-home/error' = 'favorite-home/error';

type FavoriteHome = {
  user_id: string,
  home_id: string,
  interested: boolean
}

export type Action =
  | {
    type: typeof POST_FAVORITE_HOME_USER,
    favoriteParams: FavoriteHome
  }

  | {
    type: typeof FAVORITE_BY_USER,
    homes: Array<Home>
  }

  | {
    type: typeof DELETE_FAVORITE_HOME_USER,
  }

  | {
    type: typeof FAVORITE_USER_ERROR,
    error: Error
  }
  ;
